module.exports = __webpack_public_path__ + "static/logo-7e899dccec4d937329f3cc2626d0bc80.png";